(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"]) return;
  try {
    
  
//     $(document).ready(function() {
//     var swiper = new Swiper(".cardSwiper", {
//         loop: true,
//         pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//             dynamicBullets: true,
//         },
//         autoplay: {
//             delay: 2500,
        
//         }, 
//         navigation: {
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//         },
//         breakpoints: {
//             481: {
//                 slidesPerView: 1,
//             },
//             600: {
//                 slidesPerView: 2,
//                 spaceBetween: 120,
//             },
//             1025: {
//                 slidesPerView: 4,
//                 spaceBetween: 120,
//             },
//             1280: {
//                 slidesPerView: 6,
//                 spaceBetween: 80                                                                                                                                      0,
//             },
//         }
//     });
// });
  

var swiper = new Swiper(".cardSwiper", {
    // slidesPerView: 6,
    // spaceBetween: 30,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
    },
    autoplay: {
        delay: 2000,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 2,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 80,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 80,
        },
        1280: {
            slidesPerView: 6,
            spaceBetween: 60,
        },
    }
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-product-slider"]) return;
  try {
    
  var swiper = new Swiper(".cardBoxSwiper", {
    slidesPerView: document.body.classList.contains('myh-homepage') ? 2 : 1,
    spaceBetween: document.body.classList.contains('myh-homepage') ? 12 : 25,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      481: { slidesPerView: document.body.classList.contains('myh-homepage') ? 2 : 1 },
      600: { slidesPerView: 2, spaceBetweenSlides: 20, spaceBetween: document.body.classList.contains('myh-homepage') ? 20 : 25 },
      1025: { slidesPerView: 3, spaceBetweenSlides: 20, spaceBetween: document.body.classList.contains('myh-homepage') ? 20 : 25 },
      1280: { slidesPerView: 4, spaceBetweenSlides: 25, spaceBetween: 25 }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // MYH Meteor wrapper semantics: preserve the app's own menu and DOM position.
  (function () {
    var observedLists = new WeakSet();
    function observeNavigation(root) {
      root.querySelectorAll('.header__inline-menu > ul.list-menu--inline').forEach(function (list) {
        if (observedLists.has(list)) return;
        observedLists.add(list);
        var originalRole = list.getAttribute('role');
        function updateRole() {
          var child = list.children.length === 1 ? list.firstElementChild : null;
          var platform = list.getAttribute('data-meteor-platform');
          var mounted = list.getAttribute('data-meteor-mounted') === 'true';
          var meteorRoot = child && platform === 'desktop' && child.id === 'meteor-desktop-nav' && child.getAttribute('role') === 'menubar';
          var role = mounted && meteorRoot ? 'presentation' : originalRole;
          if (role === null) list.removeAttribute('role');
          else if (list.getAttribute('role') !== role) list.setAttribute('role', role);
        }
        updateRole();
        new MutationObserver(updateRole).observe(list, {
          childList: true,
          attributes: true,
          attributeFilter: ['data-meteor-mounted', 'data-meteor-platform']
        });
      });
    }
    observeNavigation(document);
    document.addEventListener('shopify:section:load', function (event) {
      observeNavigation(event.target);
    });
  })();
  // End MYH Meteor wrapper semantics.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-gallery"]) return;
  try {
    
  jQuery(document).ready(function($) {
      $('.modal-form').on('click', function(e){        
          let _href = $(this).attr("href");
          if(!$(_href) == ""){
               e.preventDefault();
              $('#app-embed-container-29367 button[data-testid="teaser-container"]').trigger('click');   
          }
      });
  });
  var swiper = new Swiper(".gallery_slider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-old"]) return;
  try {
    
  

const addCompareButtons = document.querySelectorAll('.add_compare');
addCompareButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        const customContent = this.closest(".custom_content");
        const checkbox = customContent.querySelector('input[type="checkbox"]');
        checkbox.click();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Optional helper you had; safe to keep.
  const addCompareButtons = document.querySelectorAll('.add_compare');
  addCompareButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const customContent = this.closest(".custom_content");
      const checkbox = customContent ? customContent.querySelector('input[type="checkbox"]') : null;
      if (checkbox) checkbox.click();
    });
  });
  // Server-side pagination controls the number of items per page.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myh-abdominal-live"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => root.querySelectorAll('.myh-abdominal-page').forEach(page => {
    if (page.dataset.myhReady) return;
    page.dataset.myhReady = 'true';
    const quantity = page.querySelector('[data-myh-quantity]');
    const clamp = value => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      return Math.min(max, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
    };
    page.querySelector('[data-myh-decrease]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) - (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    page.querySelector('[data-myh-increase]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) + (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    quantity?.addEventListener('change', () => quantity.value = clamp(Number(quantity.value) || Number(quantity.min) || 1));
    const row=page.querySelector('.gallery-row');
    const track=row.querySelector('.thumbs');
    const thumbs=[...track.querySelectorAll('[data-image]')];
    const prev=row.querySelector('.gallery-prev'), next=row.querySelector('.gallery-next');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior=reduced?'auto':'smooth';
    function arrows(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-1;}
    function selectImage(button){
      const hero=page.querySelector('#heroImg');hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      row.classList.add('is-selected');
      requestAnimationFrame(()=>{
        const a=button.getBoundingClientRect(),b=track.getBoundingClientRect();
        track.scrollBy({left:a.left-b.left-(b.width-a.width)/2,behavior});arrows();
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>selectImage(button)));
    prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior}));
    next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior}));
    track.addEventListener('scroll',arrows,{passive:true});
    const observer=new ResizeObserver(arrows);observer.observe(track);arrows();
    const bar=page.querySelector('.sticky');
    const barObserver=new ResizeObserver(()=>document.body.style.setProperty('--myh-cart-height',Math.ceil(bar.getBoundingClientRect().height)+'px'));
    barObserver.observe(bar);
    const variants = JSON.parse(page.querySelector('[data-myh-variants]').textContent);
    page.querySelector('[data-myh-variant]')?.addEventListener('change', event => {
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      const form = document.getElementById(quantity.getAttribute('form'));
      form.querySelector('[name="id"]').value = variant.id;
      const option = event.target.selectedOptions[0];
      page.querySelectorAll('[data-myh-price]').forEach(e => e.textContent = option.dataset.price);
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      quantity.value = clamp(Number(quantity.value) || variant.min);
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? page.dataset.addText : page.dataset.soldText;
      submit.removeAttribute('aria-disabled');
      page.querySelectorAll('.myh-final-buy').forEach(b=>{b.disabled=!variant.available;b.textContent=variant.available?page.dataset.addText:page.dataset.soldText;});
      page.querySelector('[data-stock-status]').dataset.stockState=variant.available?'available':'sold-out';
      page.querySelector('[data-stock-message]').textContent=variant.available?'In stock, ready to ship':'Sold out';
      const errors = page.querySelector('.product-form__error-message-wrapper'); if (errors) errors.hidden = true;
    });
    page.querySelectorAll('.myh-final-buy').forEach(button => button.addEventListener('click', event => {
      const form = document.getElementById(quantity.getAttribute('form'));
      event.preventDefault(); form.requestSubmit(form.querySelector('[type="submit"]'));
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();


/* Knee-wrap reviews: Proviews is the source of data, sorting and questions. */
(() => {
  const start = () => {
    const intro = document.getElementById('myh-abdominal-feedback-intro');
    if (!intro || !document.querySelector('.myh-abdominal-page')) return;
    const initiate = () => {
      const list = document.getElementById('prorw_all_review_pagination');
      if (!list || !list.querySelector('li.prorw-review')) return false;
      const root = list.closest('.shopify-section, [id^="shopify-section"]');
      if (!root || root.contains(intro) || root.dataset.myhReviewsInitialised) return false;
      if (!(intro.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      const originalText = root.textContent.replace(/\s+/g,' ');
      const avg = originalText.match(/\b([0-5](?:[.,]\d+)?)\s*\/\s*5\b/);
      const count = originalText.match(/based on\s+([\d,]+)\s+reviews?\b/i);
      if (!avg || !count) return false; // Avoid mock values or empty data.
      const average = Number(avg[1].replace(',','.'));
      const total = Number(count[1].replace(/,/g,''));
      if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isSafeInteger(total)) return false;
      root.dataset.myhReviewsInitialised = 'true';
      intro.querySelector('[data-myh-review-average]').textContent = average.toFixed(1) + ' / 5';
      intro.querySelector('[data-myh-review-count]').textContent = 'from ' + total + ' product ' + (total===1 ? 'review' : 'reviews');
      intro.querySelector('.myh-abdominal-feedback-stars').style.setProperty('--myh-star-fill', Math.min(100,average*20)+'%');

      const textNodes = node => {
        const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
        const values=[];
        while(walker.nextNode()){
          const t=(walker.currentNode.textContent || '').replace(/\s+/g,' ').trim();
          if(t) values.push(t);
        }
        return values;
      };
      const score = review => {
        for(const el of [review,...review.querySelectorAll('[aria-label],[title],[data-rating],[data-stars]')]){
          for(const key of ['aria-label','title','data-rating','data-stars']){
            const val=el.getAttribute(key)||'';
            const m=val.match(/([0-5](?:\.\d+)?)\s*(?:out of\s*5|\/\s*5|stars?)/i) ||
              val.match(/^\s*([0-5](?:\.\d+)?)\s*$/);
            if(m) return Number(m[1]);
          }
        }
        for(const el of review.querySelectorAll('[class*="star"],[class*="rating"]')){
          const t=(el.textContent||'').replace(/\s/g,'');
          if(/^[★☆]{5}$/.test(t)) return (t.match(/★/g)||[]).length;
          const filled=el.querySelectorAll('.fa-star:not(.fa-star-o),.fas.fa-star,.filled,.star-full');
          if(filled.length>=1 && filled.length<=5) return filled.length;
        }
        return null;
      };
      const extract = review => {
        const leaves=textNodes(review);
        const selectors=['.prorw-reviewer-name','.prorw-review-name','.prorw-review-author',
          '[class*="reviewer-name"]','[class*="author-name"]','[class*="customer-name"]'];
        let name=selectors.map(sel=>review.querySelector(sel)?.textContent?.trim()).find(t=>t && t.length<65);
        if(!name) name=leaves.slice(0,12).find(t=>t.length>2 && t.length<=45 &&
          !/^(?:[A-Z]{1,3}|[★☆]+|\d+|review|rated)$/i.test(t) &&
          !/\b(?:ago|days?|weeks?|months?|years?|hours?|stars?|reviews?)\b/i.test(t));
        const wrap=review.querySelector('.prorw-review-wrap,.prorw-review-content')||review;
        const bodies=textNodes(wrap).filter(t=>t.length>12 && t!==name &&
          !/^\d+\s*(?:days?|weeks?|months?|years?)\s*ago$/i.test(t));
        const paragraphs=[...wrap.querySelectorAll('p')].map(p=>p.textContent.replace(/\s+/g,' ').trim())
          .filter(t=>t.length>12 && t!==name);
        const body=[...paragraphs,...bodies].sort((a,b)=>b.length-a.length)[0];
        const rating=score(review);
        const candidates=[...review.querySelectorAll('[class*="star"],[class*="rating"]')];
        const stars=candidates.find(el=>el.querySelectorAll('svg,i').length>=3)||
          candidates.find(el=>(el.textContent||'').includes('★') && (el.textContent||'').length<=30);
        return {name,body,rating,stars:stars?stars.cloneNode(true):null};
      };
      const createCard = item => {
        const card=document.createElement('li');card.className='myh-abdominal-mobile-card';
        const head=document.createElement('div');head.className='myh-abdominal-mobile-card-head';
        const reviewer=document.createElement('div');reviewer.className='myh-abdominal-mobile-reviewer';
        const avatar=document.createElement('span');avatar.className='myh-abdominal-mobile-avatar';
        avatar.textContent=item.name.trim().charAt(0).toUpperCase();
        const name=document.createElement('span');name.className='myh-abdominal-mobile-name';name.textContent=item.name;
        reviewer.append(avatar,name);
        const stars=document.createElement('span');stars.className='myh-abdominal-mobile-stars';
        if(item.rating!==null){
          stars.textContent='★'.repeat(Math.floor(item.rating))+'☆'.repeat(5-Math.floor(item.rating));
          stars.setAttribute('aria-label',item.rating+' out of 5 stars');
        }else if(item.stars){
          item.stars.removeAttribute('id');
          item.stars.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          stars.append(item.stars);
        }
        head.append(reviewer,stars);
        const quote=document.createElement('blockquote');quote.className='myh-abdominal-mobile-quote';
        quote.textContent='“'+item.body+'”';
        const caption=document.createElement('div');caption.className='myh-abdominal-mobile-caption';
        caption.textContent='MY Hot/Cold Abdominal Gel Wrap';
        card.append(head,quote,caption);
        return card;
      };
      const nativeAvatars = () => {
        root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review').forEach(card=>{
          const author=extract(card).name;
          const initial=author ? author.trim().charAt(0).toUpperCase() : '';
          if (!/^[A-Z]$/.test(initial)) return;
          const authorInitials=(author.match(/\b[A-Za-z]/g)||[]).join('').toUpperCase();
          const candidates=[...card.querySelectorAll('*')];
          const leaf=candidates.find(el=>{
            if(el.children.length!==0) return false;
            const label=(el.textContent||'').trim().toUpperCase();
            return label===authorInitials && label.length<=3;
          });
          const oldAvatars=[...card.querySelectorAll('[class*="avatar"],[class*="initial"]')];
          const old=oldAvatars.find(el=>(el.textContent||'').trim().length<=3);
          const letterNode=leaf||old;
          if(!letterNode)return;
          // Prefer the actual avatar circle over a nested text span.
          let circle=letterNode;
          const parent=letterNode.parentElement;
          const isCircleWrapper=parent&&parent!==card&&
            /avatar|initial|profile|portrait|picture|user-?icon|letter|user-?image/i.test(String(parent.className||'')) &&
            (parent.textContent||'').trim().length<=3;
          if(isCircleWrapper)circle=parent;
          if((letterNode.textContent||'').trim()!==initial)letterNode.textContent=initial;
          if(!circle.classList.contains('myh-abdominal-native-avatar'))circle.classList.add('myh-abdominal-native-avatar');
        });
      };
      const loadedCards = () => [...root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review')];
      const initial=loadedCards();
      const ranked=initial.map((card,index)=>({card,index,rating:score(card)}))
        .sort((a,b)=>(b.rating??-1)-(a.rating??-1)||a.index-b.index).slice(0,2);
      ranked.forEach((entry,index)=>{
        entry.card.classList.add('myh-abdominal-featured');
        entry.card.style.order=String(index);
      });
      nativeAvatars();
      const previewItems=ranked.map(entry=>extract(entry.card));
      let mobilePreview=null;
      if(previewItems.length===2 && previewItems.every(item=>item.name && item.body && (item.rating!==null||item.stars))){
        mobilePreview=document.createElement('ul');
        mobilePreview.className='myh-abdominal-mobile-reviews';
        mobilePreview.setAttribute('aria-label','Featured customer reviews');
        previewItems.forEach(item=>mobilePreview.append(createCard(item)));
        root.insertAdjacentElement('beforebegin',mobilePreview);
        root.classList.add('myh-abdominal-proviews-mobile-source');
      }
      let node=list;
      while(node && node!==root){
        for(const sibling of node.parentElement.children)if(sibling!==node)sibling.classList.add('myh-abdominal-proviews-extra');
        node=node.parentElement;
      }
      const supplement=document.createElement('div');supplement.className='myh-abdominal-review-supplement';
      root.insertAdjacentElement('afterend',supplement);
      const link=document.createElement('a');link.id='myh-abdominal-reviews-expand';
      link.href='#prorw_reviews_widget_title';link.textContent='Read the complete customer reviews ↗';
      supplement.append(link);
      const expandedMobile=document.createElement('ul');expandedMobile.className='myh-abdominal-mobile-expanded-reviews';
      expandedMobile.setAttribute('aria-label','Complete product reviews');expandedMobile.hidden=true;
      supplement.append(expandedMobile);
      const actions=document.createElement('div');actions.className='myh-abdominal-review-actions';actions.hidden=true;
      const more=document.createElement('button');more.type='button';more.id='myh-abdominal-more-ten';
      more.textContent='Show 10 more reviews';actions.append(more);supplement.append(actions);
      let visibleLimit=10;
      const markNativeReviewRegion=()=>{
        const currentList=root.querySelector('#prorw_all_review_pagination');
        if(!currentList)return;
        const select=root.querySelector('select,[role="combobox"]');
        const heading=root.querySelector('#prorw_reviews_widget_title');
        // Ascend only as far as a wrapper that does not contain the sort control
        // or widget heading: these controls must remain usable.
        let region=currentList;
        while(region.parentElement&&region.parentElement!==root){
          const parent=region.parentElement;
          if((select&&parent.contains(select))||(heading&&parent.contains(heading)))break;
          region=parent;
        }
        // The nearest dedicated review container holds the app carousel/arrows.
        if(region!==root)region.classList.add('myh-abdominal-native-review-region');
      };
      const renderExpanded = () => {
        if(!root.classList.contains('myh-abdominal-proviews-expanded'))return;
        markNativeReviewRegion();
        nativeAvatars();
        const cards=loadedCards();
        cards.forEach((card,index)=>{
          card.style.removeProperty('order');
          card.classList.toggle('myh-abdominal-ten-hidden',index>=visibleLimit);
        });
        expandedMobile.replaceChildren();
        cards.slice(0,visibleLimit).map(extract).filter(item=>item.name && item.body).forEach(item=>{
          expandedMobile.append(createCard(item));
        });
        more.hidden=cards.length<=visibleLimit;
      };
      more.addEventListener('click',()=>{visibleLimit+=10;renderExpanded();});
      let pending=false;
      const schedule=()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;renderExpanded();});
      };
      // Keep Proviews' own sorting/actions live, and refresh the supplementary mobile list on changes.
      root.addEventListener('change',e=>{
        if(e.target.matches('select,[role="combobox"]')){visibleLimit=10;schedule();}
      });
      // Keep Proviews as the data source. When it redraws a sorted page,
      // reapply the one-letter preview avatars or rebuild the expanded view.
      const observer=new MutationObserver(muts=>{
        if(!muts.some(m=>m.type==='childList'))return;
        if(root.classList.contains('myh-abdominal-proviews-expanded'))schedule();
        else requestAnimationFrame(()=>nativeAvatars());
      });
      observer.observe(root,{childList:true,subtree:true});
      link.addEventListener('click',event=>{
        event.preventDefault();
        root.classList.remove('myh-abdominal-proviews-compact','myh-abdominal-proviews-mobile-source');
        root.classList.add('myh-abdominal-proviews-expanded');
        root.querySelectorAll('.myh-abdominal-proviews-extra').forEach(el=>el.classList.remove('myh-abdominal-proviews-extra'));
        if(mobilePreview)mobilePreview.hidden=true;
        intro.hidden=true;link.hidden=true;visibleLimit=10;
        actions.hidden=false;expandedMobile.hidden=false;
        renderExpanded();
        root.querySelector('#prorw_reviews_widget_title')?.scrollIntoView({block:'start',behavior:'smooth'});
      });
      root.classList.add('myh-abdominal-proviews-compact');
      intro.hidden=false;
      return true;
    };
    if(initiate())return;
    const observer=new MutationObserver(()=>{if(initiate())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myh-gel-cap-live"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => root.querySelectorAll('.myh-gel-cap-page').forEach(page => {
    if (page.dataset.myhReady) return;
    page.dataset.myhReady = 'true';
    const quantity = page.querySelector('[data-myh-quantity]');
    const clamp = value => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      return Math.min(max, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
    };
    page.querySelector('[data-myh-decrease]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) - (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    page.querySelector('[data-myh-increase]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) + (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    quantity?.addEventListener('change', () => quantity.value = clamp(Number(quantity.value) || Number(quantity.min) || 1));
    const row=page.querySelector('.gallery-row');
    const track=row.querySelector('.thumbs');
    const thumbs=[...track.querySelectorAll('[data-image]')];
    const prev=row.querySelector('.gallery-prev'), next=row.querySelector('.gallery-next');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior=reduced?'auto':'smooth';
    function arrows(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-1;}
    function selectImage(button){
      const hero=page.querySelector('#heroImg');hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      row.classList.add('is-selected');
      requestAnimationFrame(()=>{
        const a=button.getBoundingClientRect(),b=track.getBoundingClientRect();
        track.scrollBy({left:a.left-b.left-(b.width-a.width)/2,behavior});arrows();
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>selectImage(button)));
    prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior}));
    next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior}));
    track.addEventListener('scroll',arrows,{passive:true});
    const observer=new ResizeObserver(arrows);observer.observe(track);arrows();
    const bar=page.querySelector('.sticky');
    const barObserver=new ResizeObserver(()=>document.body.style.setProperty('--myh-cart-height',Math.ceil(bar.getBoundingClientRect().height)+'px'));
    barObserver.observe(bar);
    const variants = JSON.parse(page.querySelector('[data-myh-variants]').textContent);
    page.querySelector('[data-myh-variant]')?.addEventListener('change', event => {
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      const form = document.getElementById(quantity.getAttribute('form'));
      form.querySelector('[name="id"]').value = variant.id;
      const option = event.target.selectedOptions[0];
      page.querySelectorAll('[data-myh-price]').forEach(e => e.textContent = option.dataset.price);
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      quantity.value = clamp(Number(quantity.value) || variant.min);
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? page.dataset.addText : page.dataset.soldText;
      submit.removeAttribute('aria-disabled');
      page.querySelectorAll('.myh-final-buy').forEach(b=>{b.disabled=!variant.available;b.textContent=variant.available?page.dataset.addText:page.dataset.soldText;});
      page.querySelector('[data-stock-status]').dataset.stockState=variant.available?'available':'sold-out';
      page.querySelector('[data-stock-message]').textContent=variant.available?'In stock, ready to ship':'Sold out';
      const errors = page.querySelector('.product-form__error-message-wrapper'); if (errors) errors.hidden = true;
    });
    page.querySelectorAll('.myh-final-buy').forEach(button => button.addEventListener('click', event => {
      const form = document.getElementById(quantity.getAttribute('form'));
      event.preventDefault(); form.requestSubmit(form.querySelector('[type="submit"]'));
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();


/* Knee-wrap reviews: Proviews is the source of data, sorting and questions. */
(() => {
  const start = () => {
    const intro = document.getElementById('myh-gel-cap-feedback-intro');
    if (!intro || !document.querySelector('.myh-gel-cap-page')) return;
    const initiate = () => {
      const list = document.getElementById('prorw_all_review_pagination');
      if (!list || !list.querySelector('li.prorw-review')) return false;
      const root = list.closest('.shopify-section, [id^="shopify-section"]');
      if (!root || root.contains(intro) || root.dataset.myhReviewsInitialised) return false;
      if (!(intro.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      const originalText = root.textContent.replace(/\s+/g,' ');
      const avg = originalText.match(/\b([0-5](?:[.,]\d+)?)\s*\/\s*5\b/);
      const count = originalText.match(/based on\s+([\d,]+)\s+reviews?\b/i);
      if (!avg || !count) return false; // Avoid mock values or empty data.
      const average = Number(avg[1].replace(',','.'));
      const total = Number(count[1].replace(/,/g,''));
      if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isSafeInteger(total)) return false;
      root.dataset.myhReviewsInitialised = 'true';
      intro.querySelector('[data-myh-review-average]').textContent = average.toFixed(1) + ' / 5';
      intro.querySelector('[data-myh-review-count]').textContent = 'from ' + total + ' product ' + (total===1 ? 'review' : 'reviews');
      intro.querySelector('.myh-gel-cap-feedback-stars').style.setProperty('--myh-star-fill', Math.min(100,average*20)+'%');

      const textNodes = node => {
        const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
        const values=[];
        while(walker.nextNode()){
          const t=(walker.currentNode.textContent || '').replace(/\s+/g,' ').trim();
          if(t) values.push(t);
        }
        return values;
      };
      const score = review => {
        for(const el of [review,...review.querySelectorAll('[aria-label],[title],[data-rating],[data-stars]')]){
          for(const key of ['aria-label','title','data-rating','data-stars']){
            const val=el.getAttribute(key)||'';
            const m=val.match(/([0-5](?:\.\d+)?)\s*(?:out of\s*5|\/\s*5|stars?)/i) ||
              val.match(/^\s*([0-5](?:\.\d+)?)\s*$/);
            if(m) return Number(m[1]);
          }
        }
        for(const el of review.querySelectorAll('[class*="star"],[class*="rating"]')){
          const t=(el.textContent||'').replace(/\s/g,'');
          if(/^[★☆]{5}$/.test(t)) return (t.match(/★/g)||[]).length;
          const filled=el.querySelectorAll('.fa-star:not(.fa-star-o),.fas.fa-star,.filled,.star-full');
          if(filled.length>=1 && filled.length<=5) return filled.length;
        }
        return null;
      };
      const extract = review => {
        const leaves=textNodes(review);
        const selectors=['.prorw-reviewer-name','.prorw-review-name','.prorw-review-author',
          '[class*="reviewer-name"]','[class*="author-name"]','[class*="customer-name"]'];
        let name=selectors.map(sel=>review.querySelector(sel)?.textContent?.trim()).find(t=>t && t.length<65);
        if(!name) name=leaves.slice(0,12).find(t=>t.length>2 && t.length<=45 &&
          !/^(?:[A-Z]{1,3}|[★☆]+|\d+|review|rated)$/i.test(t) &&
          !/\b(?:ago|days?|weeks?|months?|years?|hours?|stars?|reviews?)\b/i.test(t));
        const wrap=review.querySelector('.prorw-review-wrap,.prorw-review-content')||review;
        const bodies=textNodes(wrap).filter(t=>t.length>12 && t!==name &&
          !/^\d+\s*(?:days?|weeks?|months?|years?)\s*ago$/i.test(t));
        const paragraphs=[...wrap.querySelectorAll('p')].map(p=>p.textContent.replace(/\s+/g,' ').trim())
          .filter(t=>t.length>12 && t!==name);
        const body=[...paragraphs,...bodies].sort((a,b)=>b.length-a.length)[0];
        const rating=score(review);
        const candidates=[...review.querySelectorAll('[class*="star"],[class*="rating"]')];
        const stars=candidates.find(el=>el.querySelectorAll('svg,i').length>=3)||
          candidates.find(el=>(el.textContent||'').includes('★') && (el.textContent||'').length<=30);
        return {name,body,rating,stars:stars?stars.cloneNode(true):null};
      };
      const createCard = item => {
        const card=document.createElement('li');card.className='myh-gel-cap-mobile-card';
        const head=document.createElement('div');head.className='myh-gel-cap-mobile-card-head';
        const reviewer=document.createElement('div');reviewer.className='myh-gel-cap-mobile-reviewer';
        const avatar=document.createElement('span');avatar.className='myh-gel-cap-mobile-avatar';
        avatar.textContent=item.name.trim().charAt(0).toUpperCase();
        const name=document.createElement('span');name.className='myh-gel-cap-mobile-name';name.textContent=item.name;
        reviewer.append(avatar,name);
        const stars=document.createElement('span');stars.className='myh-gel-cap-mobile-stars';
        if(item.rating!==null){
          stars.textContent='★'.repeat(Math.floor(item.rating))+'☆'.repeat(5-Math.floor(item.rating));
          stars.setAttribute('aria-label',item.rating+' out of 5 stars');
        }else if(item.stars){
          item.stars.removeAttribute('id');
          item.stars.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          stars.append(item.stars);
        }
        head.append(reviewer,stars);
        const quote=document.createElement('blockquote');quote.className='myh-gel-cap-mobile-quote';
        quote.textContent='“'+item.body+'”';
        const caption=document.createElement('div');caption.className='myh-gel-cap-mobile-caption';
        caption.textContent='MY Hot/Cold Reusable Gel Cap';
        card.append(head,quote,caption);
        return card;
      };
      const nativeAvatars = () => {
        root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review').forEach(card=>{
          const author=extract(card).name;
          const initial=author ? author.trim().charAt(0).toUpperCase() : '';
          if (!/^[A-Z]$/.test(initial)) return;
          const authorInitials=(author.match(/\b[A-Za-z]/g)||[]).join('').toUpperCase();
          const candidates=[...card.querySelectorAll('*')];
          const leaf=candidates.find(el=>{
            if(el.children.length!==0) return false;
            const label=(el.textContent||'').trim().toUpperCase();
            return label===authorInitials && label.length<=3;
          });
          const oldAvatars=[...card.querySelectorAll('[class*="avatar"],[class*="initial"]')];
          const old=oldAvatars.find(el=>(el.textContent||'').trim().length<=3);
          const letterNode=leaf||old;
          if(!letterNode)return;
          // Prefer the actual avatar circle over a nested text span.
          let circle=letterNode;
          const parent=letterNode.parentElement;
          const isCircleWrapper=parent&&parent!==card&&
            /avatar|initial|profile|portrait|picture|user-?icon|letter|user-?image/i.test(String(parent.className||'')) &&
            (parent.textContent||'').trim().length<=3;
          if(isCircleWrapper)circle=parent;
          if((letterNode.textContent||'').trim()!==initial)letterNode.textContent=initial;
          if(!circle.classList.contains('myh-gel-cap-native-avatar'))circle.classList.add('myh-gel-cap-native-avatar');
        });
      };
      const loadedCards = () => [...root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review')];
      const initial=loadedCards();
      const ranked=initial.map((card,index)=>({card,index,rating:score(card)}))
        .sort((a,b)=>(b.rating??-1)-(a.rating??-1)||a.index-b.index).slice(0,2);
      ranked.forEach((entry,index)=>{
        entry.card.classList.add('myh-gel-cap-featured');
        entry.card.style.order=String(index);
      });
      nativeAvatars();
      const previewItems=ranked.map(entry=>extract(entry.card));
      let mobilePreview=null;
      if(previewItems.length===2 && previewItems.every(item=>item.name && item.body && (item.rating!==null||item.stars))){
        mobilePreview=document.createElement('ul');
        mobilePreview.className='myh-gel-cap-mobile-reviews';
        mobilePreview.setAttribute('aria-label','Featured customer reviews');
        previewItems.forEach(item=>mobilePreview.append(createCard(item)));
        root.insertAdjacentElement('beforebegin',mobilePreview);
        root.classList.add('myh-gel-cap-proviews-mobile-source');
      }
      let node=list;
      while(node && node!==root){
        for(const sibling of node.parentElement.children)if(sibling!==node)sibling.classList.add('myh-gel-cap-proviews-extra');
        node=node.parentElement;
      }
      const supplement=document.createElement('div');supplement.className='myh-gel-cap-review-supplement';
      root.insertAdjacentElement('afterend',supplement);
      const link=document.createElement('a');link.id='myh-gel-cap-reviews-expand';
      link.href='#prorw_reviews_widget_title';link.textContent='Read the complete customer reviews ↗';
      supplement.append(link);
      const expandedMobile=document.createElement('ul');expandedMobile.className='myh-gel-cap-mobile-expanded-reviews';
      expandedMobile.setAttribute('aria-label','Complete product reviews');expandedMobile.hidden=true;
      supplement.append(expandedMobile);
      const actions=document.createElement('div');actions.className='myh-gel-cap-review-actions';actions.hidden=true;
      const more=document.createElement('button');more.type='button';more.id='myh-gel-cap-more-ten';
      more.textContent='Show 10 more reviews';actions.append(more);supplement.append(actions);
      let visibleLimit=10;
      const markNativeReviewRegion=()=>{
        const currentList=root.querySelector('#prorw_all_review_pagination');
        if(!currentList)return;
        const select=root.querySelector('select,[role="combobox"]');
        const heading=root.querySelector('#prorw_reviews_widget_title');
        // Ascend only as far as a wrapper that does not contain the sort control
        // or widget heading: these controls must remain usable.
        let region=currentList;
        while(region.parentElement&&region.parentElement!==root){
          const parent=region.parentElement;
          if((select&&parent.contains(select))||(heading&&parent.contains(heading)))break;
          region=parent;
        }
        // The nearest dedicated review container holds the app carousel/arrows.
        if(region!==root)region.classList.add('myh-gel-cap-native-review-region');
      };
      const renderExpanded = () => {
        if(!root.classList.contains('myh-gel-cap-proviews-expanded'))return;
        markNativeReviewRegion();
        nativeAvatars();
        const cards=loadedCards();
        cards.forEach((card,index)=>{
          card.style.removeProperty('order');
          card.classList.toggle('myh-gel-cap-ten-hidden',index>=visibleLimit);
        });
        expandedMobile.replaceChildren();
        cards.slice(0,visibleLimit).map(extract).filter(item=>item.name && item.body).forEach(item=>{
          expandedMobile.append(createCard(item));
        });
        more.hidden=cards.length<=visibleLimit;
      };
      more.addEventListener('click',()=>{visibleLimit+=10;renderExpanded();});
      let pending=false;
      const schedule=()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;renderExpanded();});
      };
      // Keep Proviews' own sorting/actions live, and refresh the supplementary mobile list on changes.
      root.addEventListener('change',e=>{
        if(e.target.matches('select,[role="combobox"]')){visibleLimit=10;schedule();}
      });
      // Keep Proviews as the data source. When it redraws a sorted page,
      // reapply the one-letter preview avatars or rebuild the expanded view.
      const observer=new MutationObserver(muts=>{
        if(!muts.some(m=>m.type==='childList'))return;
        if(root.classList.contains('myh-gel-cap-proviews-expanded'))schedule();
        else requestAnimationFrame(()=>nativeAvatars());
      });
      observer.observe(root,{childList:true,subtree:true});
      link.addEventListener('click',event=>{
        event.preventDefault();
        root.classList.remove('myh-gel-cap-proviews-compact','myh-gel-cap-proviews-mobile-source');
        root.classList.add('myh-gel-cap-proviews-expanded');
        root.querySelectorAll('.myh-gel-cap-proviews-extra').forEach(el=>el.classList.remove('myh-gel-cap-proviews-extra'));
        if(mobilePreview)mobilePreview.hidden=true;
        intro.hidden=true;link.hidden=true;visibleLimit=10;
        actions.hidden=false;expandedMobile.hidden=false;
        renderExpanded();
        root.querySelector('#prorw_reviews_widget_title')?.scrollIntoView({block:'start',behavior:'smooth'});
      });
      root.classList.add('myh-gel-cap-proviews-compact');
      intro.hidden=false;
      return true;
    };
    if(initiate())return;
    const observer=new MutationObserver(()=>{if(initiate())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myh-ice-ankle-live"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => root.querySelectorAll('.myh-ice-ankle-page').forEach(page => {
    if (page.dataset.myhReady) return;
    page.dataset.myhReady = 'true';
    const quantity = page.querySelector('[data-myh-quantity]');
    const clamp = value => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      return Math.min(max, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
    };
    page.querySelector('[data-myh-decrease]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) - (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    page.querySelector('[data-myh-increase]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) + (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    quantity?.addEventListener('change', () => quantity.value = clamp(Number(quantity.value) || Number(quantity.min) || 1));
    const row=page.querySelector('.gallery-row');
    const track=row.querySelector('.thumbs');
    const thumbs=[...track.querySelectorAll('[data-image]')];
    const prev=row.querySelector('.gallery-prev'), next=row.querySelector('.gallery-next');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior=reduced?'auto':'smooth';
    function arrows(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-1;}
    function selectImage(button){
      const hero=page.querySelector('#heroImg');hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      row.classList.add('is-selected');
      requestAnimationFrame(()=>{
        const a=button.getBoundingClientRect(),b=track.getBoundingClientRect();
        track.scrollBy({left:a.left-b.left-(b.width-a.width)/2,behavior});arrows();
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>selectImage(button)));
    prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior}));
    next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior}));
    track.addEventListener('scroll',arrows,{passive:true});
    const observer=new ResizeObserver(arrows);observer.observe(track);arrows();
    const bar=page.querySelector('.sticky');
    const barObserver=new ResizeObserver(()=>document.body.style.setProperty('--myh-cart-height',Math.ceil(bar.getBoundingClientRect().height)+'px'));
    barObserver.observe(bar);
    const variants = JSON.parse(page.querySelector('[data-myh-variants]').textContent);
    page.querySelector('[data-myh-variant]')?.addEventListener('change', event => {
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      const form = document.getElementById(quantity.getAttribute('form'));
      form.querySelector('[name="id"]').value = variant.id;
      const option = event.target.selectedOptions[0];
      page.querySelectorAll('[data-myh-price]').forEach(e => e.textContent = option.dataset.price);
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      quantity.value = clamp(Number(quantity.value) || variant.min);
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? page.dataset.addText : page.dataset.soldText;
      submit.removeAttribute('aria-disabled');
      page.querySelectorAll('.myh-final-buy').forEach(b=>{b.disabled=!variant.available;b.textContent=variant.available?page.dataset.addText:page.dataset.soldText;});
      page.querySelector('[data-stock-status]').dataset.stockState=variant.available?'available':'sold-out';
      page.querySelector('[data-stock-message]').textContent=variant.available?'In stock, ready to ship':'Sold out';
      const errors = page.querySelector('.product-form__error-message-wrapper'); if (errors) errors.hidden = true;
    });
    page.querySelectorAll('.myh-final-buy').forEach(button => button.addEventListener('click', event => {
      const form = document.getElementById(quantity.getAttribute('form'));
      event.preventDefault(); form.requestSubmit(form.querySelector('[type="submit"]'));
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();


/* Ankle-wrap reviews: Proviews is the source of data, sorting and questions. */
(() => {
  const start = () => {
    const intro = document.getElementById('myh-ice-ankle-feedback-intro');
    if (!intro || !document.querySelector('.myh-ice-ankle-page')) return;
    const initiate = () => {
      const list = document.getElementById('prorw_all_review_pagination');
      if (!list || !list.querySelector('li.prorw-review')) return false;
      const root = list.closest('.shopify-section, [id^="shopify-section"]');
      if (!root || root.contains(intro) || root.dataset.myhReviewsInitialised) return false;
      if (!(intro.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      const originalText = root.textContent.replace(/\s+/g,' ');
      const avg = originalText.match(/\b([0-5](?:[.,]\d+)?)\s*\/\s*5\b/);
      const count = originalText.match(/based on\s+([\d,]+)\s+reviews?\b/i);
      if (!avg || !count) return false; // Avoid mock values or empty data.
      const average = Number(avg[1].replace(',','.'));
      const total = Number(count[1].replace(/,/g,''));
      if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isSafeInteger(total)) return false;
      root.dataset.myhReviewsInitialised = 'true';
      intro.querySelector('[data-myh-review-average]').textContent = average.toFixed(1) + ' / 5';
      intro.querySelector('[data-myh-review-count]').textContent = 'from ' + total + ' product ' + (total===1 ? 'review' : 'reviews');
      intro.querySelector('.myh-ice-ankle-feedback-stars').style.setProperty('--myh-star-fill', Math.min(100,average*20)+'%');

      const textNodes = node => {
        const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
        const values=[];
        while(walker.nextNode()){
          const t=(walker.currentNode.textContent || '').replace(/\s+/g,' ').trim();
          if(t) values.push(t);
        }
        return values;
      };
      const score = review => {
        for(const el of [review,...review.querySelectorAll('[aria-label],[title],[data-rating],[data-stars]')]){
          for(const key of ['aria-label','title','data-rating','data-stars']){
            const val=el.getAttribute(key)||'';
            const m=val.match(/([0-5](?:\.\d+)?)\s*(?:out of\s*5|\/\s*5|stars?)/i) ||
              val.match(/^\s*([0-5](?:\.\d+)?)\s*$/);
            if(m) return Number(m[1]);
          }
        }
        for(const el of review.querySelectorAll('[class*="star"],[class*="rating"]')){
          const t=(el.textContent||'').replace(/\s/g,'');
          if(/^[★☆]{5}$/.test(t)) return (t.match(/★/g)||[]).length;
          const filled=el.querySelectorAll('.fa-star:not(.fa-star-o),.fas.fa-star,.filled,.star-full');
          if(filled.length>=1 && filled.length<=5) return filled.length;
        }
        return null;
      };
      const extract = review => {
        const leaves=textNodes(review);
        const selectors=['.prorw-reviewer-name','.prorw-review-name','.prorw-review-author',
          '[class*="reviewer-name"]','[class*="author-name"]','[class*="customer-name"]'];
        let name=selectors.map(sel=>review.querySelector(sel)?.textContent?.trim()).find(t=>t && t.length<65);
        if(!name) name=leaves.slice(0,12).find(t=>t.length>2 && t.length<=45 &&
          !/^(?:[A-Z]{1,3}|[★☆]+|\d+|review|rated)$/i.test(t) &&
          !/\b(?:ago|days?|weeks?|months?|years?|hours?|stars?|reviews?)\b/i.test(t));
        const wrap=review.querySelector('.prorw-review-wrap,.prorw-review-content')||review;
        const bodies=textNodes(wrap).filter(t=>t.length>12 && t!==name &&
          !/^\d+\s*(?:days?|weeks?|months?|years?)\s*ago$/i.test(t));
        const paragraphs=[...wrap.querySelectorAll('p')].map(p=>p.textContent.replace(/\s+/g,' ').trim())
          .filter(t=>t.length>12 && t!==name);
        const body=[...paragraphs,...bodies].sort((a,b)=>b.length-a.length)[0];
        const rating=score(review);
        const candidates=[...review.querySelectorAll('[class*="star"],[class*="rating"]')];
        const stars=candidates.find(el=>el.querySelectorAll('svg,i').length>=3)||
          candidates.find(el=>(el.textContent||'').includes('★') && (el.textContent||'').length<=30);
        return {name,body,rating,stars:stars?stars.cloneNode(true):null};
      };
      const createCard = item => {
        const card=document.createElement('li');card.className='myh-ice-ankle-mobile-card';
        const head=document.createElement('div');head.className='myh-ice-ankle-mobile-card-head';
        const reviewer=document.createElement('div');reviewer.className='myh-ice-ankle-mobile-reviewer';
        const avatar=document.createElement('span');avatar.className='myh-ice-ankle-mobile-avatar';
        avatar.textContent=item.name.trim().charAt(0).toUpperCase();
        const name=document.createElement('span');name.className='myh-ice-ankle-mobile-name';name.textContent=item.name;
        reviewer.append(avatar,name);
        const stars=document.createElement('span');stars.className='myh-ice-ankle-mobile-stars';
        if(item.rating!==null){
          stars.textContent='★'.repeat(Math.floor(item.rating))+'☆'.repeat(5-Math.floor(item.rating));
          stars.setAttribute('aria-label',item.rating+' out of 5 stars');
        }else if(item.stars){
          item.stars.removeAttribute('id');
          item.stars.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          stars.append(item.stars);
        }
        head.append(reviewer,stars);
        const quote=document.createElement('blockquote');quote.className='myh-ice-ankle-mobile-quote';
        quote.textContent='“'+item.body+'”';
        const caption=document.createElement('div');caption.className='myh-ice-ankle-mobile-caption';
        caption.textContent='MY Ice Compression Wrap – Ankle';
        card.append(head,quote,caption);
        return card;
      };
      const nativeAvatars = () => {
        root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review').forEach(card=>{
          const author=extract(card).name;
          const initial=author ? author.trim().charAt(0).toUpperCase() : '';
          if (!/^[A-Z]$/.test(initial)) return;
          const authorInitials=(author.match(/\b[A-Za-z]/g)||[]).join('').toUpperCase();
          const candidates=[...card.querySelectorAll('*')];
          const leaf=candidates.find(el=>{
            if(el.children.length!==0) return false;
            const label=(el.textContent||'').trim().toUpperCase();
            return label===authorInitials && label.length<=3;
          });
          const oldAvatars=[...card.querySelectorAll('[class*="avatar"],[class*="initial"]')];
          const old=oldAvatars.find(el=>(el.textContent||'').trim().length<=3);
          const letterNode=leaf||old;
          if(!letterNode)return;
          // Prefer the actual avatar circle over a nested text span.
          let circle=letterNode;
          const parent=letterNode.parentElement;
          const isCircleWrapper=parent&&parent!==card&&
            /avatar|initial|profile|portrait|picture|user-?icon|letter|user-?image/i.test(String(parent.className||'')) &&
            (parent.textContent||'').trim().length<=3;
          if(isCircleWrapper)circle=parent;
          if((letterNode.textContent||'').trim()!==initial)letterNode.textContent=initial;
          if(!circle.classList.contains('myh-ice-ankle-native-avatar'))circle.classList.add('myh-ice-ankle-native-avatar');
        });
      };
      const loadedCards = () => [...root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review')];
      const initial=loadedCards();
      const ranked=initial.map((card,index)=>({card,index,rating:score(card)}))
        .sort((a,b)=>(b.rating??-1)-(a.rating??-1)||a.index-b.index).slice(0,2);
      ranked.forEach((entry,index)=>{
        entry.card.classList.add('myh-ice-ankle-featured');
        entry.card.style.order=String(index);
      });
      nativeAvatars();
      const previewItems=ranked.map(entry=>extract(entry.card));
      let mobilePreview=null;
      if(previewItems.length===2 && previewItems.every(item=>item.name && item.body && (item.rating!==null||item.stars))){
        mobilePreview=document.createElement('ul');
        mobilePreview.className='myh-ice-ankle-mobile-reviews';
        mobilePreview.setAttribute('aria-label','Featured customer reviews');
        previewItems.forEach(item=>mobilePreview.append(createCard(item)));
        root.insertAdjacentElement('beforebegin',mobilePreview);
        root.classList.add('myh-ice-ankle-proviews-mobile-source');
      }
      let node=list;
      while(node && node!==root){
        for(const sibling of node.parentElement.children)if(sibling!==node)sibling.classList.add('myh-ice-ankle-proviews-extra');
        node=node.parentElement;
      }
      const supplement=document.createElement('div');supplement.className='myh-ice-ankle-review-supplement';
      root.insertAdjacentElement('afterend',supplement);
      const link=document.createElement('a');link.id='myh-ice-ankle-reviews-expand';
      link.href='#prorw_reviews_widget_title';link.textContent='Read the complete customer reviews ↗';
      supplement.append(link);
      const expandedMobile=document.createElement('ul');expandedMobile.className='myh-ice-ankle-mobile-expanded-reviews';
      expandedMobile.setAttribute('aria-label','Complete product reviews');expandedMobile.hidden=true;
      supplement.append(expandedMobile);
      const actions=document.createElement('div');actions.className='myh-ice-ankle-review-actions';actions.hidden=true;
      const more=document.createElement('button');more.type='button';more.id='myh-ice-ankle-more-ten';
      more.textContent='Show 10 more reviews';actions.append(more);supplement.append(actions);
      let visibleLimit=10;
      const markNativeReviewRegion=()=>{
        const currentList=root.querySelector('#prorw_all_review_pagination');
        if(!currentList)return;
        const select=root.querySelector('select,[role="combobox"]');
        const heading=root.querySelector('#prorw_reviews_widget_title');
        // Ascend only as far as a wrapper that does not contain the sort control
        // or widget heading: these controls must remain usable.
        let region=currentList;
        while(region.parentElement&&region.parentElement!==root){
          const parent=region.parentElement;
          if((select&&parent.contains(select))||(heading&&parent.contains(heading)))break;
          region=parent;
        }
        // The nearest dedicated review container holds the app carousel/arrows.
        if(region!==root)region.classList.add('myh-ice-ankle-native-review-region');
      };
      const renderExpanded = () => {
        if(!root.classList.contains('myh-ice-ankle-proviews-expanded'))return;
        markNativeReviewRegion();
        nativeAvatars();
        const cards=loadedCards();
        cards.forEach((card,index)=>{
          card.style.removeProperty('order');
          card.classList.toggle('myh-ice-ankle-ten-hidden',index>=visibleLimit);
        });
        expandedMobile.replaceChildren();
        cards.slice(0,visibleLimit).map(extract).filter(item=>item.name && item.body).forEach(item=>{
          expandedMobile.append(createCard(item));
        });
        more.hidden=cards.length<=visibleLimit;
      };
      more.addEventListener('click',()=>{visibleLimit+=10;renderExpanded();});
      let pending=false;
      const schedule=()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;renderExpanded();});
      };
      // Keep Proviews' own sorting/actions live, and refresh the supplementary mobile list on changes.
      root.addEventListener('change',e=>{
        if(e.target.matches('select,[role="combobox"]')){visibleLimit=10;schedule();}
      });
      // Keep Proviews as the data source. When it redraws a sorted page,
      // reapply the one-letter preview avatars or rebuild the expanded view.
      const observer=new MutationObserver(muts=>{
        if(!muts.some(m=>m.type==='childList'))return;
        if(root.classList.contains('myh-ice-ankle-proviews-expanded'))schedule();
        else requestAnimationFrame(()=>nativeAvatars());
      });
      observer.observe(root,{childList:true,subtree:true});
      link.addEventListener('click',event=>{
        event.preventDefault();
        root.classList.remove('myh-ice-ankle-proviews-compact','myh-ice-ankle-proviews-mobile-source');
        root.classList.add('myh-ice-ankle-proviews-expanded');
        root.querySelectorAll('.myh-ice-ankle-proviews-extra').forEach(el=>el.classList.remove('myh-ice-ankle-proviews-extra'));
        if(mobilePreview)mobilePreview.hidden=true;
        intro.hidden=true;link.hidden=true;visibleLimit=10;
        actions.hidden=false;expandedMobile.hidden=false;
        renderExpanded();
        root.querySelector('#prorw_reviews_widget_title')?.scrollIntoView({block:'start',behavior:'smooth'});
      });
      root.classList.add('myh-ice-ankle-proviews-compact');
      intro.hidden=false;
      return true;
    };
    if(initiate())return;
    const observer=new MutationObserver(()=>{if(initiate())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myh-ice-knee-live"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => root.querySelectorAll('.myh-ice-knee-page').forEach(page => {
    if (page.dataset.myhReady) return;
    page.dataset.myhReady = 'true';
    const quantity = page.querySelector('[data-myh-quantity]');
    const clamp = value => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      return Math.min(max, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
    };
    page.querySelector('[data-myh-decrease]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) - (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    page.querySelector('[data-myh-increase]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) + (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    quantity?.addEventListener('change', () => quantity.value = clamp(Number(quantity.value) || Number(quantity.min) || 1));
    const row=page.querySelector('.gallery-row');
    const track=row.querySelector('.thumbs');
    const thumbs=[...track.querySelectorAll('[data-image]')];
    const prev=row.querySelector('.gallery-prev'), next=row.querySelector('.gallery-next');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior=reduced?'auto':'smooth';
    function arrows(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-1;}
    function selectImage(button){
      const hero=page.querySelector('#heroImg');hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      row.classList.add('is-selected');
      requestAnimationFrame(()=>{
        const a=button.getBoundingClientRect(),b=track.getBoundingClientRect();
        track.scrollBy({left:a.left-b.left-(b.width-a.width)/2,behavior});arrows();
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>selectImage(button)));
    prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior}));
    next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior}));
    track.addEventListener('scroll',arrows,{passive:true});
    const observer=new ResizeObserver(arrows);observer.observe(track);arrows();
    const bar=page.querySelector('.sticky');
    const barObserver=new ResizeObserver(()=>document.body.style.setProperty('--myh-cart-height',Math.ceil(bar.getBoundingClientRect().height)+'px'));
    barObserver.observe(bar);
    const variants = JSON.parse(page.querySelector('[data-myh-variants]').textContent);
    page.querySelector('[data-myh-variant]')?.addEventListener('change', event => {
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      const form = document.getElementById(quantity.getAttribute('form'));
      form.querySelector('[name="id"]').value = variant.id;
      const option = event.target.selectedOptions[0];
      page.querySelectorAll('[data-myh-price]').forEach(e => e.textContent = option.dataset.price);
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      quantity.value = clamp(Number(quantity.value) || variant.min);
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? page.dataset.addText : page.dataset.soldText;
      submit.removeAttribute('aria-disabled');
      page.querySelectorAll('.myh-final-buy').forEach(b=>{b.disabled=!variant.available;b.textContent=variant.available?page.dataset.addText:page.dataset.soldText;});
      page.querySelector('[data-stock-status]').dataset.stockState=variant.available?'available':'sold-out';
      page.querySelector('[data-stock-message]').textContent=variant.available?'In stock, ready to ship':'Sold out';
      const errors = page.querySelector('.product-form__error-message-wrapper'); if (errors) errors.hidden = true;
    });
    page.querySelectorAll('.myh-final-buy').forEach(button => button.addEventListener('click', event => {
      const form = document.getElementById(quantity.getAttribute('form'));
      event.preventDefault(); form.requestSubmit(form.querySelector('[type="submit"]'));
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();


/* Knee-wrap reviews: Proviews is the source of data, sorting and questions. */
(() => {
  const start = () => {
    const intro = document.getElementById('myh-ice-knee-feedback-intro');
    if (!intro || !document.querySelector('.myh-ice-knee-page')) return;
    const initiate = () => {
      const list = document.getElementById('prorw_all_review_pagination');
      if (!list || !list.querySelector('li.prorw-review')) return false;
      const root = list.closest('.shopify-section, [id^="shopify-section"]');
      if (!root || root.contains(intro) || root.dataset.myhReviewsInitialised) return false;
      if (!(intro.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      const originalText = root.textContent.replace(/\s+/g,' ');
      const avg = originalText.match(/\b([0-5](?:[.,]\d+)?)\s*\/\s*5\b/);
      const count = originalText.match(/based on\s+([\d,]+)\s+reviews?\b/i);
      if (!avg || !count) return false; // Avoid mock values or empty data.
      const average = Number(avg[1].replace(',','.'));
      const total = Number(count[1].replace(/,/g,''));
      if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isSafeInteger(total)) return false;
      root.dataset.myhReviewsInitialised = 'true';
      intro.querySelector('[data-myh-review-average]').textContent = average.toFixed(1) + ' / 5';
      intro.querySelector('[data-myh-review-count]').textContent = 'from ' + total + ' product ' + (total===1 ? 'review' : 'reviews');
      intro.querySelector('.myh-ice-knee-feedback-stars').style.setProperty('--myh-star-fill', Math.min(100,average*20)+'%');

      const textNodes = node => {
        const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
        const values=[];
        while(walker.nextNode()){
          const t=(walker.currentNode.textContent || '').replace(/\s+/g,' ').trim();
          if(t) values.push(t);
        }
        return values;
      };
      const score = review => {
        for(const el of [review,...review.querySelectorAll('[aria-label],[title],[data-rating],[data-stars]')]){
          for(const key of ['aria-label','title','data-rating','data-stars']){
            const val=el.getAttribute(key)||'';
            const m=val.match(/([0-5](?:\.\d+)?)\s*(?:out of\s*5|\/\s*5|stars?)/i) ||
              val.match(/^\s*([0-5](?:\.\d+)?)\s*$/);
            if(m) return Number(m[1]);
          }
        }
        for(const el of review.querySelectorAll('[class*="star"],[class*="rating"]')){
          const t=(el.textContent||'').replace(/\s/g,'');
          if(/^[★☆]{5}$/.test(t)) return (t.match(/★/g)||[]).length;
          const filled=el.querySelectorAll('.fa-star:not(.fa-star-o),.fas.fa-star,.filled,.star-full');
          if(filled.length>=1 && filled.length<=5) return filled.length;
        }
        return null;
      };
      const extract = review => {
        const leaves=textNodes(review);
        const selectors=['.prorw-reviewer-name','.prorw-review-name','.prorw-review-author',
          '[class*="reviewer-name"]','[class*="author-name"]','[class*="customer-name"]'];
        let name=selectors.map(sel=>review.querySelector(sel)?.textContent?.trim()).find(t=>t && t.length<65);
        if(!name) name=leaves.slice(0,12).find(t=>t.length>2 && t.length<=45 &&
          !/^(?:[A-Z]{1,3}|[★☆]+|\d+|review|rated)$/i.test(t) &&
          !/\b(?:ago|days?|weeks?|months?|years?|hours?|stars?|reviews?)\b/i.test(t));
        const wrap=review.querySelector('.prorw-review-wrap,.prorw-review-content')||review;
        const bodies=textNodes(wrap).filter(t=>t.length>12 && t!==name &&
          !/^\d+\s*(?:days?|weeks?|months?|years?)\s*ago$/i.test(t));
        const paragraphs=[...wrap.querySelectorAll('p')].map(p=>p.textContent.replace(/\s+/g,' ').trim())
          .filter(t=>t.length>12 && t!==name);
        const body=[...paragraphs,...bodies].sort((a,b)=>b.length-a.length)[0];
        const rating=score(review);
        const candidates=[...review.querySelectorAll('[class*="star"],[class*="rating"]')];
        const stars=candidates.find(el=>el.querySelectorAll('svg,i').length>=3)||
          candidates.find(el=>(el.textContent||'').includes('★') && (el.textContent||'').length<=30);
        return {name,body,rating,stars:stars?stars.cloneNode(true):null};
      };
      const createCard = item => {
        const card=document.createElement('li');card.className='myh-ice-knee-mobile-card';
        const head=document.createElement('div');head.className='myh-ice-knee-mobile-card-head';
        const reviewer=document.createElement('div');reviewer.className='myh-ice-knee-mobile-reviewer';
        const avatar=document.createElement('span');avatar.className='myh-ice-knee-mobile-avatar';
        avatar.textContent=item.name.trim().charAt(0).toUpperCase();
        const name=document.createElement('span');name.className='myh-ice-knee-mobile-name';name.textContent=item.name;
        reviewer.append(avatar,name);
        const stars=document.createElement('span');stars.className='myh-ice-knee-mobile-stars';
        if(item.rating!==null){
          stars.textContent='★'.repeat(Math.floor(item.rating))+'☆'.repeat(5-Math.floor(item.rating));
          stars.setAttribute('aria-label',item.rating+' out of 5 stars');
        }else if(item.stars){
          item.stars.removeAttribute('id');
          item.stars.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          stars.append(item.stars);
        }
        head.append(reviewer,stars);
        const quote=document.createElement('blockquote');quote.className='myh-ice-knee-mobile-quote';
        quote.textContent='“'+item.body+'”';
        const caption=document.createElement('div');caption.className='myh-ice-knee-mobile-caption';
        caption.textContent='MY Ice Compression Wrap – Knee';
        card.append(head,quote,caption);
        return card;
      };
      const nativeAvatars = () => {
        root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review').forEach(card=>{
          const author=extract(card).name;
          const initial=author ? author.trim().charAt(0).toUpperCase() : '';
          if (!/^[A-Z]$/.test(initial)) return;
          const authorInitials=(author.match(/\b[A-Za-z]/g)||[]).join('').toUpperCase();
          const candidates=[...card.querySelectorAll('*')];
          const leaf=candidates.find(el=>{
            if(el.children.length!==0) return false;
            const label=(el.textContent||'').trim().toUpperCase();
            return label===authorInitials && label.length<=3;
          });
          const oldAvatars=[...card.querySelectorAll('[class*="avatar"],[class*="initial"]')];
          const old=oldAvatars.find(el=>(el.textContent||'').trim().length<=3);
          const letterNode=leaf||old;
          if(!letterNode)return;
          // Prefer the actual avatar circle over a nested text span.
          let circle=letterNode;
          const parent=letterNode.parentElement;
          const isCircleWrapper=parent&&parent!==card&&
            /avatar|initial|profile|portrait|picture|user-?icon|letter|user-?image/i.test(String(parent.className||'')) &&
            (parent.textContent||'').trim().length<=3;
          if(isCircleWrapper)circle=parent;
          if((letterNode.textContent||'').trim()!==initial)letterNode.textContent=initial;
          if(!circle.classList.contains('myh-ice-knee-native-avatar'))circle.classList.add('myh-ice-knee-native-avatar');
        });
      };
      const loadedCards = () => [...root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review')];
      const initial=loadedCards();
      const ranked=initial.map((card,index)=>({card,index,rating:score(card)}))
        .sort((a,b)=>(b.rating??-1)-(a.rating??-1)||a.index-b.index).slice(0,2);
      ranked.forEach((entry,index)=>{
        entry.card.classList.add('myh-ice-knee-featured');
        entry.card.style.order=String(index);
      });
      nativeAvatars();
      const previewItems=ranked.map(entry=>extract(entry.card));
      let mobilePreview=null;
      if(previewItems.length===2 && previewItems.every(item=>item.name && item.body && (item.rating!==null||item.stars))){
        mobilePreview=document.createElement('ul');
        mobilePreview.className='myh-ice-knee-mobile-reviews';
        mobilePreview.setAttribute('aria-label','Featured customer reviews');
        previewItems.forEach(item=>mobilePreview.append(createCard(item)));
        root.insertAdjacentElement('beforebegin',mobilePreview);
        root.classList.add('myh-ice-knee-proviews-mobile-source');
      }
      let node=list;
      while(node && node!==root){
        for(const sibling of node.parentElement.children)if(sibling!==node)sibling.classList.add('myh-ice-knee-proviews-extra');
        node=node.parentElement;
      }
      const supplement=document.createElement('div');supplement.className='myh-ice-knee-review-supplement';
      root.insertAdjacentElement('afterend',supplement);
      const link=document.createElement('a');link.id='myh-ice-knee-reviews-expand';
      link.href='#prorw_reviews_widget_title';link.textContent='Read the complete customer reviews ↗';
      supplement.append(link);
      const expandedMobile=document.createElement('ul');expandedMobile.className='myh-ice-knee-mobile-expanded-reviews';
      expandedMobile.setAttribute('aria-label','Complete product reviews');expandedMobile.hidden=true;
      supplement.append(expandedMobile);
      const actions=document.createElement('div');actions.className='myh-ice-knee-review-actions';actions.hidden=true;
      const more=document.createElement('button');more.type='button';more.id='myh-ice-knee-more-ten';
      more.textContent='Show 10 more reviews';actions.append(more);supplement.append(actions);
      let visibleLimit=10;
      const markNativeReviewRegion=()=>{
        const currentList=root.querySelector('#prorw_all_review_pagination');
        if(!currentList)return;
        const select=root.querySelector('select,[role="combobox"]');
        const heading=root.querySelector('#prorw_reviews_widget_title');
        // Ascend only as far as a wrapper that does not contain the sort control
        // or widget heading: these controls must remain usable.
        let region=currentList;
        while(region.parentElement&&region.parentElement!==root){
          const parent=region.parentElement;
          if((select&&parent.contains(select))||(heading&&parent.contains(heading)))break;
          region=parent;
        }
        // The nearest dedicated review container holds the app carousel/arrows.
        if(region!==root)region.classList.add('myh-ice-knee-native-review-region');
      };
      const renderExpanded = () => {
        if(!root.classList.contains('myh-ice-knee-proviews-expanded'))return;
        markNativeReviewRegion();
        nativeAvatars();
        const cards=loadedCards();
        cards.forEach((card,index)=>{
          card.style.removeProperty('order');
          card.classList.toggle('myh-ice-knee-ten-hidden',index>=visibleLimit);
        });
        expandedMobile.replaceChildren();
        cards.slice(0,visibleLimit).map(extract).filter(item=>item.name && item.body).forEach(item=>{
          expandedMobile.append(createCard(item));
        });
        more.hidden=cards.length<=visibleLimit;
      };
      more.addEventListener('click',()=>{visibleLimit+=10;renderExpanded();});
      let pending=false;
      const schedule=()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;renderExpanded();});
      };
      // Keep Proviews' own sorting/actions live, and refresh the supplementary mobile list on changes.
      root.addEventListener('change',e=>{
        if(e.target.matches('select,[role="combobox"]')){visibleLimit=10;schedule();}
      });
      // Keep Proviews as the data source. When it redraws a sorted page,
      // reapply the one-letter preview avatars or rebuild the expanded view.
      const observer=new MutationObserver(muts=>{
        if(!muts.some(m=>m.type==='childList'))return;
        if(root.classList.contains('myh-ice-knee-proviews-expanded'))schedule();
        else requestAnimationFrame(()=>nativeAvatars());
      });
      observer.observe(root,{childList:true,subtree:true});
      link.addEventListener('click',event=>{
        event.preventDefault();
        root.classList.remove('myh-ice-knee-proviews-compact','myh-ice-knee-proviews-mobile-source');
        root.classList.add('myh-ice-knee-proviews-expanded');
        root.querySelectorAll('.myh-ice-knee-proviews-extra').forEach(el=>el.classList.remove('myh-ice-knee-proviews-extra'));
        if(mobilePreview)mobilePreview.hidden=true;
        intro.hidden=true;link.hidden=true;visibleLimit=10;
        actions.hidden=false;expandedMobile.hidden=false;
        renderExpanded();
        root.querySelector('#prorw_reviews_widget_title')?.scrollIntoView({block:'start',behavior:'smooth'});
      });
      root.classList.add('myh-ice-knee-proviews-compact');
      intro.hidden=false;
      return true;
    };
    if(initiate())return;
    const observer=new MutationObserver(()=>{if(initiate())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myh-knee-live"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => root.querySelectorAll('.myh-knee-page').forEach(page => {
    if (page.dataset.myhReady) return;
    page.dataset.myhReady = 'true';
    const quantity = page.querySelector('[data-myh-quantity]');
    const clamp = value => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      return Math.min(max, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
    };
    page.querySelector('[data-myh-decrease]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) - (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    page.querySelector('[data-myh-increase]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) + (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    quantity?.addEventListener('change', () => quantity.value = clamp(Number(quantity.value) || Number(quantity.min) || 1));
    const row=page.querySelector('.gallery-row');
    const track=row.querySelector('.thumbs');
    const thumbs=[...track.querySelectorAll('[data-image]')];
    const prev=row.querySelector('.gallery-prev'), next=row.querySelector('.gallery-next');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior=reduced?'auto':'smooth';
    function arrows(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-1;}
    function selectImage(button){
      const hero=page.querySelector('#heroImg');hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      row.classList.add('is-selected');
      requestAnimationFrame(()=>{
        const a=button.getBoundingClientRect(),b=track.getBoundingClientRect();
        track.scrollBy({left:a.left-b.left-(b.width-a.width)/2,behavior});arrows();
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>selectImage(button)));
    prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior}));
    next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior}));
    track.addEventListener('scroll',arrows,{passive:true});
    const observer=new ResizeObserver(arrows);observer.observe(track);arrows();
    const bar=page.querySelector('.sticky');
    const barObserver=new ResizeObserver(()=>document.body.style.setProperty('--myh-cart-height',Math.ceil(bar.getBoundingClientRect().height)+'px'));
    barObserver.observe(bar);
    const variants = JSON.parse(page.querySelector('[data-myh-variants]').textContent);
    page.querySelector('[data-myh-variant]')?.addEventListener('change', event => {
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      const form = document.getElementById(quantity.getAttribute('form'));
      form.querySelector('[name="id"]').value = variant.id;
      const option = event.target.selectedOptions[0];
      page.querySelectorAll('[data-myh-price]').forEach(e => e.textContent = option.dataset.price);
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      quantity.value = clamp(Number(quantity.value) || variant.min);
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? page.dataset.addText : page.dataset.soldText;
      submit.removeAttribute('aria-disabled');
      page.querySelectorAll('.myh-final-buy').forEach(b=>{b.disabled=!variant.available;b.textContent=variant.available?page.dataset.addText:page.dataset.soldText;});
      page.querySelector('[data-stock-status]').dataset.stockState=variant.available?'available':'sold-out';
      page.querySelector('[data-stock-message]').textContent=variant.available?'In stock, ready to ship':'Sold out';
      const errors = page.querySelector('.product-form__error-message-wrapper'); if (errors) errors.hidden = true;
    });
    page.querySelectorAll('.myh-final-buy').forEach(button => button.addEventListener('click', event => {
      const form = document.getElementById(quantity.getAttribute('form'));
      event.preventDefault(); form.requestSubmit(form.querySelector('[type="submit"]'));
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();


/* Knee-wrap reviews: Proviews is the source of data, sorting and questions. */
(() => {
  const start = () => {
    const intro = document.getElementById('myh-knee-feedback-intro');
    if (!intro || !document.querySelector('.myh-knee-page')) return;
    const initiate = () => {
      const list = document.getElementById('prorw_all_review_pagination');
      if (!list || !list.querySelector('li.prorw-review')) return false;
      const root = list.closest('.shopify-section, [id^="shopify-section"]');
      if (!root || root.contains(intro) || root.dataset.myhReviewsInitialised) return false;
      if (!(intro.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      const originalText = root.textContent.replace(/\s+/g,' ');
      const avg = originalText.match(/\b([0-5](?:[.,]\d+)?)\s*\/\s*5\b/);
      const count = originalText.match(/based on\s+([\d,]+)\s+reviews?\b/i);
      if (!avg || !count) return false; // Avoid mock values or empty data.
      const average = Number(avg[1].replace(',','.'));
      const total = Number(count[1].replace(/,/g,''));
      if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isSafeInteger(total)) return false;
      root.dataset.myhReviewsInitialised = 'true';
      intro.querySelector('[data-myh-review-average]').textContent = average.toFixed(1) + ' / 5';
      intro.querySelector('[data-myh-review-count]').textContent = 'from ' + total + ' product ' + (total===1 ? 'review' : 'reviews');
      intro.querySelector('.myh-knee-feedback-stars').style.setProperty('--myh-star-fill', Math.min(100,average*20)+'%');

      const textNodes = node => {
        const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
        const values=[];
        while(walker.nextNode()){
          const t=(walker.currentNode.textContent || '').replace(/\s+/g,' ').trim();
          if(t) values.push(t);
        }
        return values;
      };
      const score = review => {
        for(const el of [review,...review.querySelectorAll('[aria-label],[title],[data-rating],[data-stars]')]){
          for(const key of ['aria-label','title','data-rating','data-stars']){
            const val=el.getAttribute(key)||'';
            const m=val.match(/([0-5](?:\.\d+)?)\s*(?:out of\s*5|\/\s*5|stars?)/i) ||
              val.match(/^\s*([0-5](?:\.\d+)?)\s*$/);
            if(m) return Number(m[1]);
          }
        }
        for(const el of review.querySelectorAll('[class*="star"],[class*="rating"]')){
          const t=(el.textContent||'').replace(/\s/g,'');
          if(/^[★☆]{5}$/.test(t)) return (t.match(/★/g)||[]).length;
          const filled=el.querySelectorAll('.fa-star:not(.fa-star-o),.fas.fa-star,.filled,.star-full');
          if(filled.length>=1 && filled.length<=5) return filled.length;
        }
        return null;
      };
      const extract = review => {
        const leaves=textNodes(review);
        const selectors=['.prorw-reviewer-name','.prorw-review-name','.prorw-review-author',
          '[class*="reviewer-name"]','[class*="author-name"]','[class*="customer-name"]'];
        let name=selectors.map(sel=>review.querySelector(sel)?.textContent?.trim()).find(t=>t && t.length<65);
        if(!name) name=leaves.slice(0,12).find(t=>t.length>2 && t.length<=45 &&
          !/^(?:[A-Z]{1,3}|[★☆]+|\d+|review|rated)$/i.test(t) &&
          !/\b(?:ago|days?|weeks?|months?|years?|hours?|stars?|reviews?)\b/i.test(t));
        const wrap=review.querySelector('.prorw-review-wrap,.prorw-review-content')||review;
        const bodies=textNodes(wrap).filter(t=>t.length>12 && t!==name &&
          !/^\d+\s*(?:days?|weeks?|months?|years?)\s*ago$/i.test(t));
        const paragraphs=[...wrap.querySelectorAll('p')].map(p=>p.textContent.replace(/\s+/g,' ').trim())
          .filter(t=>t.length>12 && t!==name);
        const body=[...paragraphs,...bodies].sort((a,b)=>b.length-a.length)[0];
        const rating=score(review);
        const candidates=[...review.querySelectorAll('[class*="star"],[class*="rating"]')];
        const stars=candidates.find(el=>el.querySelectorAll('svg,i').length>=3)||
          candidates.find(el=>(el.textContent||'').includes('★') && (el.textContent||'').length<=30);
        return {name,body,rating,stars:stars?stars.cloneNode(true):null};
      };
      const createCard = item => {
        const card=document.createElement('li');card.className='myh-knee-mobile-card';
        const head=document.createElement('div');head.className='myh-knee-mobile-card-head';
        const reviewer=document.createElement('div');reviewer.className='myh-knee-mobile-reviewer';
        const avatar=document.createElement('span');avatar.className='myh-knee-mobile-avatar';
        avatar.textContent=item.name.trim().charAt(0).toUpperCase();
        const name=document.createElement('span');name.className='myh-knee-mobile-name';name.textContent=item.name;
        reviewer.append(avatar,name);
        const stars=document.createElement('span');stars.className='myh-knee-mobile-stars';
        if(item.rating!==null){
          stars.textContent='★'.repeat(Math.floor(item.rating))+'☆'.repeat(5-Math.floor(item.rating));
          stars.setAttribute('aria-label',item.rating+' out of 5 stars');
        }else if(item.stars){
          item.stars.removeAttribute('id');
          item.stars.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          stars.append(item.stars);
        }
        head.append(reviewer,stars);
        const quote=document.createElement('blockquote');quote.className='myh-knee-mobile-quote';
        quote.textContent='“'+item.body+'”';
        const caption=document.createElement('div');caption.className='myh-knee-mobile-caption';
        caption.textContent='MY Hot & Cold Knee Wrap';
        card.append(head,quote,caption);
        return card;
      };
      const nativeAvatars = () => {
        root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review').forEach(card=>{
          const author=extract(card).name;
          const initial=author ? author.trim().charAt(0).toUpperCase() : '';
          if (!/^[A-Z]$/.test(initial)) return;
          const authorInitials=(author.match(/\b[A-Za-z]/g)||[]).join('').toUpperCase();
          const candidates=[...card.querySelectorAll('*')];
          const leaf=candidates.find(el=>{
            if(el.children.length!==0) return false;
            const label=(el.textContent||'').trim().toUpperCase();
            return label===authorInitials && label.length<=3;
          });
          const oldAvatars=[...card.querySelectorAll('[class*="avatar"],[class*="initial"]')];
          const old=oldAvatars.find(el=>(el.textContent||'').trim().length<=3);
          const letterNode=leaf||old;
          if(!letterNode)return;
          // Prefer the actual avatar circle over a nested text span.
          let circle=letterNode;
          const parent=letterNode.parentElement;
          const isCircleWrapper=parent&&parent!==card&&
            /avatar|initial|profile|portrait|picture|user-?icon|letter|user-?image/i.test(String(parent.className||'')) &&
            (parent.textContent||'').trim().length<=3;
          if(isCircleWrapper)circle=parent;
          if((letterNode.textContent||'').trim()!==initial)letterNode.textContent=initial;
          if(!circle.classList.contains('myh-knee-native-avatar'))circle.classList.add('myh-knee-native-avatar');
        });
      };
      const loadedCards = () => [...root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review')];
      const initial=loadedCards();
      const ranked=initial.map((card,index)=>({card,index,rating:score(card)}))
        .sort((a,b)=>(b.rating??-1)-(a.rating??-1)||a.index-b.index).slice(0,2);
      ranked.forEach((entry,index)=>{
        entry.card.classList.add('myh-knee-featured');
        entry.card.style.order=String(index);
      });
      nativeAvatars();
      const previewItems=ranked.map(entry=>extract(entry.card));
      let mobilePreview=null;
      if(previewItems.length===2 && previewItems.every(item=>item.name && item.body && (item.rating!==null||item.stars))){
        mobilePreview=document.createElement('ul');
        mobilePreview.className='myh-knee-mobile-reviews';
        mobilePreview.setAttribute('aria-label','Featured customer reviews');
        previewItems.forEach(item=>mobilePreview.append(createCard(item)));
        root.insertAdjacentElement('beforebegin',mobilePreview);
        root.classList.add('myh-knee-proviews-mobile-source');
      }
      let node=list;
      while(node && node!==root){
        for(const sibling of node.parentElement.children)if(sibling!==node)sibling.classList.add('myh-knee-proviews-extra');
        node=node.parentElement;
      }
      const supplement=document.createElement('div');supplement.className='myh-knee-review-supplement';
      root.insertAdjacentElement('afterend',supplement);
      const link=document.createElement('a');link.id='myh-knee-reviews-expand';
      link.href='#prorw_reviews_widget_title';link.textContent='Read the complete customer reviews ↗';
      supplement.append(link);
      const expandedMobile=document.createElement('ul');expandedMobile.className='myh-knee-mobile-expanded-reviews';
      expandedMobile.setAttribute('aria-label','Complete product reviews');expandedMobile.hidden=true;
      supplement.append(expandedMobile);
      const actions=document.createElement('div');actions.className='myh-knee-review-actions';actions.hidden=true;
      const more=document.createElement('button');more.type='button';more.id='myh-knee-more-ten';
      more.textContent='Show 10 more reviews';actions.append(more);supplement.append(actions);
      let visibleLimit=10;
      const markNativeReviewRegion=()=>{
        const currentList=root.querySelector('#prorw_all_review_pagination');
        if(!currentList)return;
        const select=root.querySelector('select,[role="combobox"]');
        const heading=root.querySelector('#prorw_reviews_widget_title');
        // Ascend only as far as a wrapper that does not contain the sort control
        // or widget heading: these controls must remain usable.
        let region=currentList;
        while(region.parentElement&&region.parentElement!==root){
          const parent=region.parentElement;
          if((select&&parent.contains(select))||(heading&&parent.contains(heading)))break;
          region=parent;
        }
        // The nearest dedicated review container holds the app carousel/arrows.
        if(region!==root)region.classList.add('myh-knee-native-review-region');
      };
      const renderExpanded = () => {
        if(!root.classList.contains('myh-knee-proviews-expanded'))return;
        markNativeReviewRegion();
        nativeAvatars();
        const cards=loadedCards();
        cards.forEach((card,index)=>{
          card.style.removeProperty('order');
          card.classList.toggle('myh-knee-ten-hidden',index>=visibleLimit);
        });
        expandedMobile.replaceChildren();
        cards.slice(0,visibleLimit).map(extract).filter(item=>item.name && item.body).forEach(item=>{
          expandedMobile.append(createCard(item));
        });
        more.hidden=cards.length<=visibleLimit;
      };
      more.addEventListener('click',()=>{visibleLimit+=10;renderExpanded();});
      let pending=false;
      const schedule=()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;renderExpanded();});
      };
      // Keep Proviews' own sorting/actions live, and refresh the supplementary mobile list on changes.
      root.addEventListener('change',e=>{
        if(e.target.matches('select,[role="combobox"]')){visibleLimit=10;schedule();}
      });
      // Keep Proviews as the data source. When it redraws a sorted page,
      // reapply the one-letter preview avatars or rebuild the expanded view.
      const observer=new MutationObserver(muts=>{
        if(!muts.some(m=>m.type==='childList'))return;
        if(root.classList.contains('myh-knee-proviews-expanded'))schedule();
        else requestAnimationFrame(()=>nativeAvatars());
      });
      observer.observe(root,{childList:true,subtree:true});
      link.addEventListener('click',event=>{
        event.preventDefault();
        root.classList.remove('myh-knee-proviews-compact','myh-knee-proviews-mobile-source');
        root.classList.add('myh-knee-proviews-expanded');
        root.querySelectorAll('.myh-knee-proviews-extra').forEach(el=>el.classList.remove('myh-knee-proviews-extra'));
        if(mobilePreview)mobilePreview.hidden=true;
        intro.hidden=true;link.hidden=true;visibleLimit=10;
        actions.hidden=false;expandedMobile.hidden=false;
        renderExpanded();
        root.querySelector('#prorw_reviews_widget_title')?.scrollIntoView({block:'start',behavior:'smooth'});
      });
      root.classList.add('myh-knee-proviews-compact');
      intro.hidden=false;
      return true;
    };
    if(initiate())return;
    const observer=new MutationObserver(()=>{if(initiate())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myh-neck-wrap-live"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => root.querySelectorAll('.myh-neck-wrap-page').forEach(page => {
    if (page.dataset.myhReady) return;
    page.dataset.myhReady = 'true';
    const quantity = page.querySelector('[data-myh-quantity]');
    const clamp = value => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      return Math.min(max, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
    };
    page.querySelector('[data-myh-decrease]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) - (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    page.querySelector('[data-myh-increase]')?.addEventListener('click', () => { quantity.value = clamp((Number(quantity.value) || Number(quantity.min) || 1) + (Number(quantity.step) || 1)); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    quantity?.addEventListener('change', () => quantity.value = clamp(Number(quantity.value) || Number(quantity.min) || 1));
    const row=page.querySelector('.gallery-row');
    const track=row.querySelector('.thumbs');
    const thumbs=[...track.querySelectorAll('[data-image]')];
    const prev=row.querySelector('.gallery-prev'), next=row.querySelector('.gallery-next');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior=reduced?'auto':'smooth';
    function arrows(){prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-1;}
    function selectImage(button){
      const hero=page.querySelector('#heroImg');hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      row.classList.add('is-selected');
      requestAnimationFrame(()=>{
        const a=button.getBoundingClientRect(),b=track.getBoundingClientRect();
        track.scrollBy({left:a.left-b.left-(b.width-a.width)/2,behavior});arrows();
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>selectImage(button)));
    prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior}));
    next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior}));
    track.addEventListener('scroll',arrows,{passive:true});
    const observer=new ResizeObserver(arrows);observer.observe(track);arrows();
    const bar=page.querySelector('.sticky');
    const barObserver=new ResizeObserver(()=>document.body.style.setProperty('--myh-cart-height',Math.ceil(bar.getBoundingClientRect().height)+'px'));
    barObserver.observe(bar);
    const variants = JSON.parse(page.querySelector('[data-myh-variants]').textContent);
    page.querySelector('[data-myh-variant]')?.addEventListener('change', event => {
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      const form = document.getElementById(quantity.getAttribute('form'));
      form.querySelector('[name="id"]').value = variant.id;
      const option = event.target.selectedOptions[0];
      page.querySelectorAll('[data-myh-price]').forEach(e => e.textContent = option.dataset.price);
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      quantity.value = clamp(Number(quantity.value) || variant.min);
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? page.dataset.addText : page.dataset.soldText;
      submit.removeAttribute('aria-disabled');
      page.querySelectorAll('.myh-final-buy').forEach(b=>{b.disabled=!variant.available;b.textContent=variant.available?page.dataset.addText:page.dataset.soldText;});
      page.querySelector('[data-stock-status]').dataset.stockState=variant.available?'available':'sold-out';
      page.querySelector('[data-stock-message]').textContent=variant.available?'In stock, ready to ship':'Sold out';
      const errors = page.querySelector('.product-form__error-message-wrapper'); if (errors) errors.hidden = true;
    });
    page.querySelectorAll('.myh-final-buy').forEach(button => button.addEventListener('click', event => {
      const form = document.getElementById(quantity.getAttribute('form'));
      event.preventDefault(); form.requestSubmit(form.querySelector('[type="submit"]'));
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();


/* Knee-wrap reviews: Proviews is the source of data, sorting and questions. */
(() => {
  const start = () => {
    const intro = document.getElementById('myh-neck-wrap-feedback-intro');
    if (!intro || !document.querySelector('.myh-neck-wrap-page')) return;
    const initiate = () => {
      const list = document.getElementById('prorw_all_review_pagination');
      if (!list || !list.querySelector('li.prorw-review')) return false;
      const root = list.closest('.shopify-section, [id^="shopify-section"]');
      if (!root || root.contains(intro) || root.dataset.myhReviewsInitialised) return false;
      if (!(intro.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      const originalText = root.textContent.replace(/\s+/g,' ');
      const avg = originalText.match(/\b([0-5](?:[.,]\d+)?)\s*\/\s*5\b/);
      const count = originalText.match(/based on\s+([\d,]+)\s+reviews?\b/i);
      if (!avg || !count) return false; // Avoid mock values or empty data.
      const average = Number(avg[1].replace(',','.'));
      const total = Number(count[1].replace(/,/g,''));
      if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isSafeInteger(total)) return false;
      root.dataset.myhReviewsInitialised = 'true';
      intro.querySelector('[data-myh-review-average]').textContent = average.toFixed(1) + ' / 5';
      intro.querySelector('[data-myh-review-count]').textContent = 'from ' + total + ' product ' + (total===1 ? 'review' : 'reviews');
      intro.querySelector('.myh-neck-wrap-feedback-stars').style.setProperty('--myh-star-fill', Math.min(100,average*20)+'%');

      const textNodes = node => {
        const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
        const values=[];
        while(walker.nextNode()){
          const t=(walker.currentNode.textContent || '').replace(/\s+/g,' ').trim();
          if(t) values.push(t);
        }
        return values;
      };
      const score = review => {
        for(const el of [review,...review.querySelectorAll('[aria-label],[title],[data-rating],[data-stars]')]){
          for(const key of ['aria-label','title','data-rating','data-stars']){
            const val=el.getAttribute(key)||'';
            const m=val.match(/([0-5](?:\.\d+)?)\s*(?:out of\s*5|\/\s*5|stars?)/i) ||
              val.match(/^\s*([0-5](?:\.\d+)?)\s*$/);
            if(m) return Number(m[1]);
          }
        }
        for(const el of review.querySelectorAll('[class*="star"],[class*="rating"]')){
          const t=(el.textContent||'').replace(/\s/g,'');
          if(/^[★☆]{5}$/.test(t)) return (t.match(/★/g)||[]).length;
          const filled=el.querySelectorAll('.fa-star:not(.fa-star-o),.fas.fa-star,.filled,.star-full');
          if(filled.length>=1 && filled.length<=5) return filled.length;
        }
        return null;
      };
      const extract = review => {
        const leaves=textNodes(review);
        const selectors=['.prorw-reviewer-name','.prorw-review-name','.prorw-review-author',
          '[class*="reviewer-name"]','[class*="author-name"]','[class*="customer-name"]'];
        let name=selectors.map(sel=>review.querySelector(sel)?.textContent?.trim()).find(t=>t && t.length<65);
        if(!name) name=leaves.slice(0,12).find(t=>t.length>2 && t.length<=45 &&
          !/^(?:[A-Z]{1,3}|[★☆]+|\d+|review|rated)$/i.test(t) &&
          !/\b(?:ago|days?|weeks?|months?|years?|hours?|stars?|reviews?)\b/i.test(t));
        const wrap=review.querySelector('.prorw-review-wrap,.prorw-review-content')||review;
        const bodies=textNodes(wrap).filter(t=>t.length>12 && t!==name &&
          !/^\d+\s*(?:days?|weeks?|months?|years?)\s*ago$/i.test(t));
        const paragraphs=[...wrap.querySelectorAll('p')].map(p=>p.textContent.replace(/\s+/g,' ').trim())
          .filter(t=>t.length>12 && t!==name);
        const body=[...paragraphs,...bodies].sort((a,b)=>b.length-a.length)[0];
        const rating=score(review);
        const candidates=[...review.querySelectorAll('[class*="star"],[class*="rating"]')];
        const stars=candidates.find(el=>el.querySelectorAll('svg,i').length>=3)||
          candidates.find(el=>(el.textContent||'').includes('★') && (el.textContent||'').length<=30);
        return {name,body,rating,stars:stars?stars.cloneNode(true):null};
      };
      const createCard = item => {
        const card=document.createElement('li');card.className='myh-neck-wrap-mobile-card';
        const head=document.createElement('div');head.className='myh-neck-wrap-mobile-card-head';
        const reviewer=document.createElement('div');reviewer.className='myh-neck-wrap-mobile-reviewer';
        const avatar=document.createElement('span');avatar.className='myh-neck-wrap-mobile-avatar';
        avatar.textContent=item.name.trim().charAt(0).toUpperCase();
        const name=document.createElement('span');name.className='myh-neck-wrap-mobile-name';name.textContent=item.name;
        reviewer.append(avatar,name);
        const stars=document.createElement('span');stars.className='myh-neck-wrap-mobile-stars';
        if(item.rating!==null){
          stars.textContent='★'.repeat(Math.floor(item.rating))+'☆'.repeat(5-Math.floor(item.rating));
          stars.setAttribute('aria-label',item.rating+' out of 5 stars');
        }else if(item.stars){
          item.stars.removeAttribute('id');
          item.stars.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          stars.append(item.stars);
        }
        head.append(reviewer,stars);
        const quote=document.createElement('blockquote');quote.className='myh-neck-wrap-mobile-quote';
        quote.textContent='“'+item.body+'”';
        const caption=document.createElement('div');caption.className='myh-neck-wrap-mobile-caption';
        caption.textContent='MY Hot/Cold Reusable Neck Wrap';
        card.append(head,quote,caption);
        return card;
      };
      const nativeAvatars = () => {
        root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review').forEach(card=>{
          const author=extract(card).name;
          const initial=author ? author.trim().charAt(0).toUpperCase() : '';
          if (!/^[A-Z]$/.test(initial)) return;
          const authorInitials=(author.match(/\b[A-Za-z]/g)||[]).join('').toUpperCase();
          const candidates=[...card.querySelectorAll('*')];
          const leaf=candidates.find(el=>{
            if(el.children.length!==0) return false;
            const label=(el.textContent||'').trim().toUpperCase();
            return label===authorInitials && label.length<=3;
          });
          const oldAvatars=[...card.querySelectorAll('[class*="avatar"],[class*="initial"]')];
          const old=oldAvatars.find(el=>(el.textContent||'').trim().length<=3);
          const letterNode=leaf||old;
          if(!letterNode)return;
          // Prefer the actual avatar circle over a nested text span.
          let circle=letterNode;
          const parent=letterNode.parentElement;
          const isCircleWrapper=parent&&parent!==card&&
            /avatar|initial|profile|portrait|picture|user-?icon|letter|user-?image/i.test(String(parent.className||'')) &&
            (parent.textContent||'').trim().length<=3;
          if(isCircleWrapper)circle=parent;
          if((letterNode.textContent||'').trim()!==initial)letterNode.textContent=initial;
          if(!circle.classList.contains('myh-neck-wrap-native-avatar'))circle.classList.add('myh-neck-wrap-native-avatar');
        });
      };
      const loadedCards = () => [...root.querySelectorAll('#prorw_all_review_pagination>li.prorw-review')];
      const initial=loadedCards();
      const ranked=initial.map((card,index)=>({card,index,rating:score(card)}))
        .sort((a,b)=>(b.rating??-1)-(a.rating??-1)||a.index-b.index).slice(0,2);
      ranked.forEach((entry,index)=>{
        entry.card.classList.add('myh-neck-wrap-featured');
        entry.card.style.order=String(index);
      });
      nativeAvatars();
      const previewItems=ranked.map(entry=>extract(entry.card));
      let mobilePreview=null;
      if(previewItems.length===2 && previewItems.every(item=>item.name && item.body && (item.rating!==null||item.stars))){
        mobilePreview=document.createElement('ul');
        mobilePreview.className='myh-neck-wrap-mobile-reviews';
        mobilePreview.setAttribute('aria-label','Featured customer reviews');
        previewItems.forEach(item=>mobilePreview.append(createCard(item)));
        root.insertAdjacentElement('beforebegin',mobilePreview);
        root.classList.add('myh-neck-wrap-proviews-mobile-source');
      }
      let node=list;
      while(node && node!==root){
        for(const sibling of node.parentElement.children)if(sibling!==node)sibling.classList.add('myh-neck-wrap-proviews-extra');
        node=node.parentElement;
      }
      const supplement=document.createElement('div');supplement.className='myh-neck-wrap-review-supplement';
      root.insertAdjacentElement('afterend',supplement);
      const link=document.createElement('a');link.id='myh-neck-wrap-reviews-expand';
      link.href='#prorw_reviews_widget_title';link.textContent='Read the complete customer reviews ↗';
      supplement.append(link);
      const expandedMobile=document.createElement('ul');expandedMobile.className='myh-neck-wrap-mobile-expanded-reviews';
      expandedMobile.setAttribute('aria-label','Complete product reviews');expandedMobile.hidden=true;
      supplement.append(expandedMobile);
      const actions=document.createElement('div');actions.className='myh-neck-wrap-review-actions';actions.hidden=true;
      const more=document.createElement('button');more.type='button';more.id='myh-neck-wrap-more-ten';
      more.textContent='Show 10 more reviews';actions.append(more);supplement.append(actions);
      let visibleLimit=10;
      const markNativeReviewRegion=()=>{
        const currentList=root.querySelector('#prorw_all_review_pagination');
        if(!currentList)return;
        const select=root.querySelector('select,[role="combobox"]');
        const heading=root.querySelector('#prorw_reviews_widget_title');
        // Ascend only as far as a wrapper that does not contain the sort control
        // or widget heading: these controls must remain usable.
        let region=currentList;
        while(region.parentElement&&region.parentElement!==root){
          const parent=region.parentElement;
          if((select&&parent.contains(select))||(heading&&parent.contains(heading)))break;
          region=parent;
        }
        // The nearest dedicated review container holds the app carousel/arrows.
        if(region!==root)region.classList.add('myh-neck-wrap-native-review-region');
      };
      const renderExpanded = () => {
        if(!root.classList.contains('myh-neck-wrap-proviews-expanded'))return;
        markNativeReviewRegion();
        nativeAvatars();
        const cards=loadedCards();
        cards.forEach((card,index)=>{
          card.style.removeProperty('order');
          card.classList.toggle('myh-neck-wrap-ten-hidden',index>=visibleLimit);
        });
        expandedMobile.replaceChildren();
        cards.slice(0,visibleLimit).map(extract).filter(item=>item.name && item.body).forEach(item=>{
          expandedMobile.append(createCard(item));
        });
        more.hidden=cards.length<=visibleLimit;
      };
      more.addEventListener('click',()=>{visibleLimit+=10;renderExpanded();});
      let pending=false;
      const schedule=()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;renderExpanded();});
      };
      // Keep Proviews' own sorting/actions live, and refresh the supplementary mobile list on changes.
      root.addEventListener('change',e=>{
        if(e.target.matches('select,[role="combobox"]')){visibleLimit=10;schedule();}
      });
      // Keep Proviews as the data source. When it redraws a sorted page,
      // reapply the one-letter preview avatars or rebuild the expanded view.
      const observer=new MutationObserver(muts=>{
        if(!muts.some(m=>m.type==='childList'))return;
        if(root.classList.contains('myh-neck-wrap-proviews-expanded'))schedule();
        else requestAnimationFrame(()=>nativeAvatars());
      });
      observer.observe(root,{childList:true,subtree:true});
      link.addEventListener('click',event=>{
        event.preventDefault();
        root.classList.remove('myh-neck-wrap-proviews-compact','myh-neck-wrap-proviews-mobile-source');
        root.classList.add('myh-neck-wrap-proviews-expanded');
        root.querySelectorAll('.myh-neck-wrap-proviews-extra').forEach(el=>el.classList.remove('myh-neck-wrap-proviews-extra'));
        if(mobilePreview)mobilePreview.hidden=true;
        intro.hidden=true;link.hidden=true;visibleLimit=10;
        actions.hidden=false;expandedMobile.hidden=false;
        renderExpanded();
        root.querySelector('#prorw_reviews_widget_title')?.scrollIntoView({block:'start',behavior:'smooth'});
      });
      root.classList.add('myh-neck-wrap-proviews-compact');
      intro.hidden=false;
      return true;
    };
    if(initiate())return;
    const observer=new MutationObserver(()=>{if(initiate())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"]) return;
  try {
    
// Shopify's native loading="lazy" still fetched distant carousel banners on
// initial page load. Keep the first slide unchanged; activate other images only
// as their slides approach view. The original Swiper options are unchanged.
function myhLoadUpcomingBanner(slide) {
    if (!slide) return;
    slide.querySelectorAll('img[data-myh-src]').forEach(function (img) {
        var sourceSet = img.getAttribute('data-myh-srcset');
        if (sourceSet) {
            img.setAttribute('srcset', sourceSet);
            img.removeAttribute('data-myh-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-myh-src'));
        img.removeAttribute('data-myh-src');
    });
}
function myhPrepareBannerNeighbours(instance) {
    if (!instance || !instance.slides || !instance.slides.length) return;
    var slides = instance.slides;
    var total = slides.length;
    var current = instance.activeIndex || 0;
    [current, current + 1, current + 2, current - 1].forEach(function (index) {
        myhLoadUpcomingBanner(slides[(index + total) % total]);
    });
}
var swiper = new Swiper(".bannerSwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
    },
    on: {
        init: myhPrepareBannerNeighbours,
        slideChange: myhPrepareBannerNeighbours,
    },
});

  




  } catch(e) { console.error(e); }
})();
})();
